/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import {
    NgbDateAdapter,
    NgbDateParserFormatter,
    NgbTimeAdapter,
} from "@ng-bootstrap/ng-bootstrap";
import { RouterModule } from "@angular/router";
import { Amplify } from "aws-amplify";
import {
    CustomDateAdapter,
    CustomDateParserFormatter,
    CustomTimeAdapter,
} from "src/app/services/helpers/dateAdapter.service";
import {
    MissingTranslationHandler,
    MissingTranslationHandlerParams,
    TranslateLoader,
    TranslateModule,
    TranslateStore,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { v4 as uuidv4 } from "uuid";
import { DateTime } from "luxon";
import { ToastrModule } from "ngx-toastr";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

/* Add Amplify imports */
import awsmobile from "../aws-exports";
import { SharedModule } from "./shared/shared.module";

import { AppConfig } from "../config/app.config";
import { NotAuthorizedComponent } from "./components/error/not-authorized/not-authorized.component";
import { WaitingRoomComponent } from "./museum/components/waiting-room/waiting-room.component";
import { MuseumAuthModule } from "./museum/museum-auth/museum-auth.module";
import { MuseumNoMissionComponent } from "./museum/components/museum-no-mission/museum-no-mission.component";
import { APIService } from "./API.service";
import { MuseumToastComponent } from "./museum/components/museum-toast/museum-toast.component";
import { LayoutComponent } from "./components/layout/layout.component";
import { AwsKinesisAnalyticsService } from "./services/aws-kinesis-analytics.service";


export function getAwsKinesisAnalyticsServiceFactory(appInitService: AwsKinesisAnalyticsService): AwsKinesisAnalyticsService {
    return appInitService;
}

/* Configure Amplify resources */
Amplify.configure({
    Logging: {
        logGroupName: "main-app",
        logStreamName: `${DateTime.now().toISODate()}-${uuidv4().slice(
            0,
            8,
        )}-museum-app`,
        region: "eu-west-1",
    },
    ...awsmobile,
});

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export function initResources(config: AppConfig) {
    return () => config.load();
}

export function getAPIServiceFactory(appInitService: APIService): APIService {
    return appInitService;
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
    handle(parameters: MissingTranslationHandlerParams) {
        // console.log(params)
        return parameters.key;
    }
}

@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        NotAuthorizedComponent,
        WaitingRoomComponent,
        MuseumNoMissionComponent,
        MuseumToastComponent,
    ],
    imports: [
        BrowserModule,
        RouterModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            toastComponent: MuseumToastComponent,
            timeOut: 3000,
            positionClass: "toast-top-center",
        }), // ToastrModule added
        TranslateModule.forRoot({
            // defaultLanguage: '_en',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MyMissingTranslationHandler,
            },
        }),
        // Routed modules
        MuseumAuthModule,
        SharedModule,
        AppRoutingModule, // AppRoutingModule MUST BE last
    ],
    providers: [
        TranslateStore,
        { provide: NgbDateAdapter, useClass: CustomDateAdapter },
        { provide: NgbTimeAdapter, useClass: CustomTimeAdapter },
        {
            provide: NgbDateParserFormatter,
            useClass: CustomDateParserFormatter,
        },
        AppConfig,
        {
            provide: APP_INITIALIZER,
            useFactory: initResources,
            deps: [AppConfig],
            multi: true,
        },
        {
            provide: "currentAwsKinesisAnalyticsService",
            useFactory: getAwsKinesisAnalyticsServiceFactory,
            deps: [AwsKinesisAnalyticsService],
        }, // for lib core!
        {
            provide: "currentAPIService",
            useFactory: getAPIServiceFactory,
            deps: [APIService],
        }, // for lib core!
        {
            provide: "SPModule",
            useValue: "MUSEUM",
        }, // for lib core
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
